const STORAGE_KEY = 'clickaway_catalog_nav'

function read () {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

function write (data) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch (e) {}
}

/**
 * Guarda la ruta del catálogo y el scroll actual antes de abrir un producto.
 */
export function saveCatalogPosition (route) {
  if (!route) return
  const name = route.name
  // Solo guardar si venimos de una vista de catálogo / lista
  const catalogNames = ['Home', 'HomeShort', 'ProductosMobile', 'MesaQRProductos', 'MesaQR']
  if (!catalogNames.includes(name)) return

  write({
    name,
    params: { ...route.params },
    query: { ...(route.query || {}) },
    fullPath: route.fullPath,
    scrollY: window.scrollY || window.pageYOffset || 0,
    savedAt: Date.now()
  })
}

export function peekCatalogPosition () {
  return read()
}

export function clearCatalogPosition () {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch (e) {}
}

/**
 * Restaura el scroll si hay una posición guardada para esta ruta.
 * Devuelve true si se programó la restauración.
 */
export function restoreCatalogScroll (route, { clear = true } = {}) {
  const data = read()
  if (!data || !route) return false
  if (data.name !== route.name) return false
  if (String(data.params && data.params.client) !== String(route.params && route.params.client)) return false

  const y = Number(data.scrollY) || 0
  const delays = [0, 80, 200, 450, 900, 1500]

  delays.forEach((delay, i) => {
    setTimeout(() => {
      window.scrollTo(0, y)
      if (clear && i === delays.length - 1) clearCatalogPosition()
    }, delay)
  })
  return true
}

/**
 * Navega de vuelta al catálogo guardado, o al fallback.
 * No usa history.back() cuando hay fallback explícito: en Android el historial
 * suele ser producto/cuenta/checkout y “atrás” no lleva a tiendas.
 */
export function goBackToCatalog (router, fallback) {
  const data = peekCatalogPosition()
  if (data && data.name) {
    return router.push({
      name: data.name,
      params: data.params || {},
      query: data.query || {}
    }).catch(() => {
      if (fallback) return router.push(fallback).catch(() => {})
    })
  }
  if (fallback) {
    return router.push(fallback).catch(() => {})
  }
  if (window.history.length > 1) {
    router.back()
  }
  return Promise.resolve()
}
